import Title from "../../../elements/Title";
import Image from "../../../elements/Image";
import { classNames } from "../../../../helpers/classNames";
import { motion } from "framer-motion";
import { postFrontDetails } from "../../../../services/postService";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { lngDetect } from "../../../common/lngDetect";

const Security = () => {
  const { data: artistData } = useQuery({
    queryKey: ["front-artist-section"],
    queryFn: async () => {
      const res = await postFrontDetails({
        slug: "artist-section",
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.data;
    },
  });

  const newArtistData = {
    title: lngDetect(artistData?.content)?.title,
    image: artistData?.mediaGallery?.[0]?.url,
    section:
      (artistData?.sections || [])?.map((item) => ({
        icon: item?.icon,
        title: item?.content,
      })) || [],
  };

  console.log({ newArtistData });

  const data = [
    {
      icon: "fa-solid fa-rocket text-3xl",
      description:
        "Revolutionary platform where you can support your favorite celebrities and creators in a whole new way",
    },
    {
      icon: "fa-solid fa-chart-line text-3xl",
      description:
        "Your engagement directly impacts your star's success! The more you play, the more they earn",
    },
    {
      icon: "fa-solid fa-users text-3xl",
      description:
        "Join millions of fans worldwide supporting their favorite personalities!",
    },
    {
      icon: "fa fa-trophy text-3xl",
      description:
        "Every spin counts! Win points ranging from 100 to 1000 that directly contribute to your star's total score and leaderboard position.",
    },
  ];

  const appStoreData = [
    { name: "Google Play", link: "/", icon: "fa-brands fa-google-play" },
    { name: "Apple Store", link: "/", icon: "fa-brands fa-apple text-2xl" },
  ];

  const container = {
    hidden: { opacity: 0, y: 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: { staggerChildren: 0.15, duration: 0.8, ease: "easeOut" },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <section className="relative py-10 xls:py-24 z-0" id="artist">
      <motion.div
        animate={{ opacity: [0.1, 0.2, 0.1], scale: [1, 1.2, 1] }}
        transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
        className="hidden lg:block absolute -top-[10vh] -left-[10vh] h-1/2 aspect-square bg-radical-red/50 rounded-full blur-3xl z-[-1]"
      />
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl-max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
        <motion.div
          className="relative"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.div className="space-y-24">
            <motion.div
              className="flex items-center justify-center"
              variants={item}
            >
              <Title title={newArtistData?.title} />
            </motion.div>
            <div className="grid sm:flex items-center gap-10 xl:gap-20 xls:max-w-8xl mx-auto">
              <div className="flex-1 space-y-12 order-2 sm:order-1">
                {newArtistData?.section?.slice(0, 2).map((itemData, i) => (
                  <motion.div
                    key={i}
                    className="space-y-4 text-center sm:text-right group"
                    variants={item}
                  >
                    <div className="flex-shrink-0 flex flex-col items-center justify-center w-16 aspect-square rounded-xl overflow-hidden bg-gradient-to-r from-yellow-400 to-orange-500 text-white shadow-[0_0_20px_rgba(250, 204, 21, 0.7)] group-hover:shadow-[0_0_35px_rgba(250, 204, 21, 1)] transition-all duration-300 ml-auto">
                      <i className={classNames("fa-fw", itemData?.icon)}></i>
                    </div>
                    <div className="space-y-2">
                      <div className="text-base xls:text-lg xl:text-xl font-semibold">
                        {itemData?.title}
                      </div>
                      {/* <div className="text-sm xl:text-base font-light text-white/90">
                        {itemData?.description}
                      </div> */}
                    </div>
                  </motion.div>
                ))}
              </div>
              <motion.div
                className="flex-shrink-0 relative w-60 lg:w-72 xl:w-80 mx-auto order-1 sm:order-2 !mb-10 !sm:mb-0"
                variants={item}
              >
                <motion.div
                  animate={{ y: [0, -15, 0] }}
                  transition={{
                    duration: 4,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                  className="relative flex overflow-hidden rounded-6xl"
                >
                  <div className="absolute inset-0 blur-2xl bg-electric-violet/40 rounded-full" />
                  <Image
                    preload={true}
                    src={newArtistData?.image}
                    alt={``}
                    effect="blur"
                    classes="object-contain relative z-10"
                  />
                </motion.div>
              </motion.div>
              <div className="flex-1 space-y-12 order-3 sm:order-3">
                {newArtistData?.section?.slice(2, 4).map((itemData, i) => (
                  <motion.div
                    key={i}
                    className="space-y-4 text-center sm:text-left group"
                    variants={item}
                  >
                    <div className="flex-shrink-0 flex flex-col items-center justify-center w-16 aspect-square rounded-xl overflow-hidden bg-gradient-to-r from-yellow-400 to-orange-500 text-white shadow-[0_0_20px_rgba(250, 204, 21, 0.7)] group-hover:shadow-[0_0_35px_rgba(250, 204, 21, 1)] transition-all duration-300 mr-auto">
                      <i className={classNames("fa-fw", itemData?.icon)}></i>
                    </div>
                    <div className="space-y-2">
                      <div className="text-base xls:text-lg xl:text-xl font-semibold">
                        {itemData?.title}
                      </div>
                      {/* <div className="text-sm xl:text-base font-light text-white/90">
                        {itemData?.description}
                      </div> */}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
            {appStoreData?.length > 0 && (
              <motion.div
                variants={item}
                className="flex items-center justify-center gap-4"
              >
                {appStoreData.map((btn, index) => (
                  <motion.a
                    key={index}
                    variants={item}
                    href={btn.link}
                    target="_blank"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="px-4 h-12 rounded-full font-black text-lg transition-all flex items-center justify-center gap-3 shadow-xl bg-gradient-to-r from-yellow-400 to-orange-500 text-[#320051] hover:from-yellow-300 hover:to-orange-400"
                  >
                    <i className={classNames("fa-fw", btn.icon)}></i>
                    <span className="text-base">{btn.name}</span>
                  </motion.a>
                ))}
              </motion.div>
            )}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Security;
